import { Spinner } from './ui/Spinner';
import type { PlanningSessionStatus } from '@pantheon/shared';

export interface SessionStatusProps {
  status: PlanningSessionStatus;
  progress?: string;
  className?: string;
}

const statusMessages: Record<PlanningSessionStatus, string> = {
  drafting: 'Setting up session...',
  ingesting_context: 'Fetching repository context...',
  generating: 'AI is generating ticket plan...',
  reviewing: 'Ready for review',
  approved: 'Approved',
  creating_tickets: 'Creating tickets in Jira...',
  completed: 'Complete',
  failed: 'Failed',
};

export function SessionStatus({ status, progress, className = '' }: SessionStatusProps) {
  const isActive = ['drafting', 'ingesting_context', 'generating', 'creating_tickets'].includes(status);
  const isFailed = status === 'failed';
  const isDone = status === 'completed';

  return (
    <div className={`flex flex-col items-center justify-center py-12 ${className}`}>
      {isActive && (
        <>
          <Spinner size="lg" className="text-primary mb-4" />
          <p className="text-base font-medium text-gray-700">{progress ?? statusMessages[status]}</p>
          <p className="text-sm text-gray-500 mt-1">This may take a minute...</p>
        </>
      )}
      {isDone && (
        <>
          <div className="w-10 h-10 rounded-full bg-success-light flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <p className="text-base font-medium text-success">Complete</p>
        </>
      )}
      {isFailed && (
        <>
          <div className="w-10 h-10 rounded-full bg-danger-light flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-danger" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <p className="text-base font-medium text-danger">Something went wrong</p>
        </>
      )}
    </div>
  );
}
